module.exports = __webpack_public_path__ + "static/media/ABCEmpData.b7eadd6b.xlsx";